export default __webpack_public_path__ + "static/008-7cb686de4d635b76c15ba9560659de9b.jpg";